var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5028 67.5968V61.159C51.5028 57.7442 50.1463 54.4692 47.7317 52.0546C45.317 49.64 42.0421 48.2834 38.6273 48.2834H19.3139C15.8991 48.2834 12.6242 49.64 10.2095 52.0546C7.79488 54.4692 6.43835 57.7442 6.43835 61.159V67.5968",
    stroke: "#DCD7C9",
    strokeWidth: 3.76846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9707 35.4079C36.0816 35.4079 41.8462 29.6433 41.8462 22.5323C41.8462 15.4213 36.0816 9.65674 28.9707 9.65674C21.8597 9.65674 16.0951 15.4213 16.0951 22.5323C16.0951 29.6433 21.8597 35.4079 28.9707 35.4079Z",
    stroke: "#DCD7C9",
    strokeWidth: 3.76846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.815 67.5965V61.1588C70.8129 58.306 69.8633 55.5346 68.1155 53.2799C66.3677 51.0252 63.9206 49.4149 61.1583 48.7017",
    stroke: "#DCD7C9",
    strokeWidth: 3.76846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5016 10.075C54.2712 10.7841 56.726 12.3948 58.479 14.6532C60.232 16.9116 61.1835 19.6892 61.1835 22.5481C61.1835 25.4071 60.232 28.1847 58.479 30.4431C56.726 32.7015 54.2712 34.3122 51.5016 35.0213",
    stroke: "#DCD7C9",
    strokeWidth: 3.76846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamicon);
export default __webpack_public_path__ + "static/media/team icon.128dc8480cc1c94fc68d1d617e737a20.svg";
export { ForwardRef as ReactComponent };